import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { createPortal } from 'react-dom';

const Portal = ({ children, ...props }) => {
  const portalElement = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const div = document.createElement('div');
    document.body.appendChild(div);
    portalElement.current = div;

    return () => {
      if (portalElement.current) {
        document.body.removeChild(portalElement.current);
      }
    };
  }, []);

  const duration = 200;
  const styles = `
    .fade-enter { opacity: 0.01; }
    .fade-enter-active { opacity: 1; transition: opacity ${duration}ms; }
    .fade-exit { opacity: 1; }
    .fade-exit-active { opacity: 0.01; transition: opacity ${duration}ms; }
  `;

  if (!portalElement.current) return null;

  return createPortal(
    <div>
      <style>{styles}</style>
      <TransitionGroup {...props}>
        <CSSTransition
          timeout={{ enter: duration, exit: duration }}
          classNames="fade"
        >
          <div>{children}</div>
        </CSSTransition>
      </TransitionGroup>
    </div>,
    portalElement.current
  );
};

Portal.propTypes = {
  children: PropTypes.node,
};

export default Portal;
